import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { useShareApplicants } from "hooks";
import { Spinner } from "components/Loader";
import { MessagesError } from "components/Messages";
import { TextArea } from "components/Form";

/**
 * ApplicantsSharePlainText
 *
 * Displays applicant data as *pure plain text*, suitable for copy/paste into emails or chat tools.
 *
 * Format:
 * Link to the Application (PIN)
 * Name, Country, Rate
 * LinkedIn
 * Role Applied to
 * Disciplines and Skills
 *
 * @param {Array} applicantIds
 */
const ApplicantsSharePlainText = ({ applicantIds }) => {
  const { loading, error, textualData } = useShareApplicants({ applicantIds });

  if (loading) return <Spinner size="1.5rem" />;
  if (error) return <MessagesError />;

  return <TextArea readOnly value={textualData} css={styles.textarea} />;
};

const styles = {
  textarea: css`
    width: 100%;
    height: 500px;
    white-space: pre-wrap;
  `,
};

ApplicantsSharePlainText.propTypes = {
  applicantIds: PropTypes.array.isRequired,
};

export default ApplicantsSharePlainText;
